import React, { createContext, useContext, useEffect, useState } from "react";
import useSanity, { TBusinessDay } from "../hooks/useSanity";

const BusinessHoursContext = createContext<Array<TBusinessDay> | undefined>(undefined);

export const BusinessHoursProvider = ({ children }: { children: React.ReactNode }) => {
  const { getBusinessHours } = useSanity();
  const [businessHours, setBusinessHours] = useState<Array<TBusinessDay> | undefined>(undefined);

  useEffect(() => {
    void getBusinessHours()
      .then(res => setBusinessHours(res))
      .catch(err => {
        console.error("Failed to fetch hours:", err);
        setBusinessHours([]);
      });
  }, []);

  return <BusinessHoursContext.Provider value={businessHours}>{children}</BusinessHoursContext.Provider>;
};

export const useBusinessHours = () => useContext(BusinessHoursContext);
